import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../../../Header/actions";
import { getPerfiles } from "../../Mantenedores/General/actions";

import { checkAccess, ids } from "../../../../helpers/rolAccess";
import SolicitudesPendientes from "./SolicitudesPendientes/view";


class Notificaciones extends React.PureComponent {
  constructor(props) {
    super(props);

    !props.perfiles.length && props.dispatch(getPerfiles());
  }
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== "Solicitudes") {
      this.loadTabs();
    }
  }

  loadTabs = () => {
    const tabs = [];

   tabs.push({ text: "Solicitudes de rol", contentId: 0 });

    this.props.dispatch(loadTabs("Solicitudes", "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return (<SolicitudesPendientes />);
      }

      default:
        return <div />;
    }
  }
  render() {
    return (
      <div style={{ paddingBottom: 60 }}>
        {this.renderBody()}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  UserInfo: state.global.userData,
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  perfiles: state.mantenedores.perfiles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Notificaciones);
